<template>
  <div>
    <client-detail
      :id="order['client']['id']"
      :fieldList="fieldList"
      @input="save"
    />
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../../plugins/functions";
import ClientDetail from "@/components/Partners/ClientDetail";
export default {
  components: {
    ClientDetail,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {},
  data() {
    return {
      fieldList: [
        {
          key: "passport_3",
          labelKey: "passport_3",
          label: "Обратная сторона  ID",
          type: "img",
        },
      ],
    };
  },
  methods: {
    async createFile(client = null, name = "passport_4") {
      console.log("client", client);
      console.log("file", client[name]);
      try {
        let response = await fetch(client[name]);

        let data = await response.blob();
        let metadata = {
          type: "image/jpeg",
        };
        const file = new File([data], `${client["id"]}_${name}.jpg`, metadata);
        return file;
      } catch (error) {
        console.log(error);
      }
      return "";
    },
    async save(data) {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      let bodyFormData = new FormData();
      bodyFormData.append("type", "ID_PASSPORT_BACK");
      bodyFormData.append("file", await this.createFile(data, "passport_3"));
      this.$http({
        url: `${partner["endpoint_url"]}clients/clients/${this.value.id}/files`,
        method: "POST",
        data: bodyFormData,
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$emit("update", true);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>